// useAlert.js
import { useContext } from 'react'
import PopupContext from './GlobalPoup'

const usePopup = () => useContext(PopupContext)

export default usePopup
